import { List, Tabs } from "@pankod/refine-antd";
import { IResourceComponentsProps } from "@pankod/refine-core";
import React, { useCallback, useMemo } from "react";
import { Tracks } from "./tracks/list";
import { Users } from "./users/list";
import { Tags } from "./tags/list";
import { Genres } from "./genres/list";
// import { Test } from "./updateManyTracks/list";

export const ImportData: React.FC<IResourceComponentsProps> = () => {
  const { TabPane } = Tabs;

  const dataTab = useMemo(
    () => [
      {
        key: "1",
        tab: "User",
        components: <Users />,
      },
      {
        key: "2",
        tab: "Track",
        components: <Tracks />,
      },
      {
        key: "3",
        tab: "Tag",
        components: <Tags />,
      },
      {
        key: "4",
        tab: "Genre",
        components: <Genres />,
      },
      // {
      //   key: "5",
      //   tab: "Test",
      //   components: <Test />,
      // },
    ],
    []
  );

  const renderListTabs = useCallback(() => {
    return dataTab.map((data) => (
      <TabPane tab={data.tab} key={data.key}>
        {data.components}
      </TabPane>
    ));
  }, [TabPane, dataTab]);

  return (
    <List>
      <Tabs defaultActiveKey="1" type="card">
        {renderListTabs()}
      </Tabs>
    </List>
  );
};
